var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css, keyframes } from 'styled-components';
const Animation = keyframes `
  0%{
    transform: translate3d(0, 0.5rem, 0);
  }

  100%{
    transform: translate3d(0, 0, 0);
  }
`;
const CircleBase = css `
  animation-name: ${Animation};
  animation-duration: 450ms;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  fill: none;
  stroke: ${({ styling: stylingProp, fillColor, theme: { colors, colorContext }, }) => {
    const styling = stylingProp || (colorContext === 'dark' ? 'primary' : 'secondary');
    return fillColor
        ? colors[fillColor]
        : styling === 'primary'
            ? colors.white
            : colors.primary;
}};
`;
const Circle1 = styled.circle `
  ${CircleBase}
  animation-delay: 0ms;
`;
const Circle2 = styled.circle `
  ${CircleBase}
  animation-delay: 60ms;
`;
const Circle3 = styled.circle `
  ${CircleBase}
  animation-delay: 120ms;
`;
export function ProgressIndicator(_a) {
    var { 'data-testid': dataTestId = 'progress-indicator', height = undefined, width = undefined } = _a, props = __rest(_a, ['data-testid', "height", "width"]);
    return (React.createElement("svg", { viewBox: "0 0 32 32", width: width, height: height, "data-testid": dataTestId },
        React.createElement("g", { strokeWidth: "2" },
            React.createElement(Circle1, Object.assign({}, props, { cx: "4", cy: "14", r: "3" })),
            React.createElement(Circle2, Object.assign({}, props, { cx: "16", cy: "14", r: "3" })),
            React.createElement(Circle3, Object.assign({}, props, { cx: "28", cy: "14", r: "3" })))));
}
